module.exports = __webpack_public_path__ + "img/footer-Rectangle.fed7dbf0.png";